// extracted by mini-css-extract-plugin
export default {"commandsPanel":"PricingModelCommandsPanel_commandsPanel__Ba13n"};